<tt-page>
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <form class="form-horizontal sp-0" name="formPohCompAddScan" novalidate (ngSubmit)="submitSearch()" method="get" role="form">
            <tt-input ttLabel="pohcompaddscan_search" ttFocus [(ttModel)]="barcode" ttShowClearButton [ttButtons]="barcodeButtons"></tt-input>
        </form>
    </tt-card>
</tt-page>
